<script setup lang="ts">
    import { computed } from 'vue';
    import { formatCurrency } from '@/utils/helpers';

    const props = withDefaults(
        defineProps<{
            value?: number;
            withColor?: boolean;
            addon?: string;
            returnZero?: boolean;
        }>(),
        {
            withColor: false,
            returnZero: false,
        },
    );

    const formattedValue = computed(() => {
        if (!props.value) return emptyValue.value;
        return formatCurrency(props.value);
    });

    const emptyValue = computed(() => {
        if (props.returnZero) return formatCurrency(0);
        return '';
    });

    const color = computed(() => {
        if (!props.value || !props.withColor) return '';
        return props.value < 0 ? 'text-destructive' : 'text-accent';
    });
</script>

<template>
    <span :class="color"> {{ formattedValue }} {{ addon }} </span>
</template>
